module.exports = __webpack_public_path__ + "media/icons/header-35ab8838.svg";